import React from 'react';
import { Check, Zap } from 'lucide-react';
import { SlideLayout } from '../SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProspectPricingSlide(props: SlideProps) {
  return <SlideLayout {...props} title="Credit-Based Pricing" subtitle="Pay only for what you use. Each question paper uses 5-20 credits based on content size." data-id="element-234">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 items-end" data-id="element-235">
        {/* Starter Pack */}
        <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm" data-id="element-236">
          <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-237">
            Starter Pack
          </h3>
          <div className="flex items-baseline gap-1 mb-1" data-id="element-238">
            <span className="text-4xl font-bold text-slate-900" data-id="element-239">
              PKR 13,500
            </span>
          </div>
          <div className="text-sm text-slate-500 mb-6" data-id="element-240">
            <div className="font-medium" data-id="element-241">100 Credits</div>
            <div className="text-xs" data-id="element-242">PKR 135/credit · ~10-20 papers</div>
          </div>
          <ul className="space-y-3 mb-8" data-id="element-243">
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-244">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-245" /> 100
              AI credits
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-246">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-247" /> All
              question types
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-248">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-249" /> PDF
              export with branding
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-250">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-251" /> Valid
              for 12 months
            </li>
          </ul>
          <button className="w-full py-3 rounded-xl border-2 border-slate-200 font-bold text-slate-600 hover:border-indigo-600 hover:text-indigo-600 transition-colors" data-id="element-252">
            Buy Credits
          </button>
        </div>

        {/* Professional */}
        <div className="bg-indigo-600 p-8 rounded-3xl shadow-xl transform scale-105 relative z-10" data-id="element-253">
          <div className="absolute top-0 right-0 bg-amber-400 text-amber-900 text-xs font-bold px-3 py-1 rounded-bl-xl rounded-tr-2xl flex items-center gap-1" data-id="element-254">
            <Zap className="w-3 h-3" data-id="element-255" />
            MOST POPULAR
          </div>
          <h3 className="text-lg font-bold text-white mb-2" data-id="element-256">Professional</h3>
          <div className="flex items-baseline gap-1 mb-1" data-id="element-257">
            <span className="text-4xl font-bold text-white" data-id="element-258">PKR 58,500</span>
          </div>
          <div className="text-sm text-indigo-100 mb-6" data-id="element-259">
            <div className="font-medium" data-id="element-260">500 Credits</div>
            <div className="text-xs flex items-center gap-2" data-id="element-261">
              PKR 117/credit · ~50-100 papers
              <span className="bg-emerald-400 text-emerald-900 text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-262">
                13% OFF
              </span>
            </div>
          </div>
          <ul className="space-y-3 mb-8" data-id="element-263">
            <li className="flex items-center gap-2 text-sm text-white" data-id="element-264">
              <Check className="w-4 h-4 text-amber-400 flex-shrink-0" data-id="element-265" /> 500 AI
              credits
            </li>
            <li className="flex items-center gap-2 text-sm text-white" data-id="element-266">
              <Check className="w-4 h-4 text-amber-400 flex-shrink-0" data-id="element-267" /> All
              question types
            </li>
            <li className="flex items-center gap-2 text-sm text-white" data-id="element-268">
              <Check className="w-4 h-4 text-amber-400 flex-shrink-0" data-id="element-269" />{' '}
              Board-specific templates
            </li>
            <li className="flex items-center gap-2 text-sm text-white" data-id="element-270">
              <Check className="w-4 h-4 text-amber-400 flex-shrink-0" data-id="element-271" /> PDF
              export with branding
            </li>
            <li className="flex items-center gap-2 text-sm text-white" data-id="element-272">
              <Check className="w-4 h-4 text-amber-400 flex-shrink-0" data-id="element-273" /> Valid
              for 12 months
            </li>
          </ul>
          <button className="w-full py-3 rounded-xl bg-white font-bold text-indigo-600 hover:bg-indigo-50 transition-colors shadow-lg" data-id="element-274">
            Buy Credits
          </button>
        </div>

        {/* Institution */}
        <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm" data-id="element-275">
          <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-276">Institution</h3>
          <div className="flex items-baseline gap-1 mb-1" data-id="element-277">
            <span className="text-4xl font-bold text-slate-900" data-id="element-278">
              PKR 216,000
            </span>
          </div>
          <div className="text-sm text-slate-500 mb-6" data-id="element-279">
            <div className="font-medium" data-id="element-280">2,000 Credits</div>
            <div className="text-xs flex items-center gap-2" data-id="element-281">
              PKR 108/credit · ~200-400 papers
              <span className="bg-emerald-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-282">
                20% OFF
              </span>
            </div>
          </div>
          <ul className="space-y-3 mb-8" data-id="element-283">
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-284">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-285" /> 2,000
              AI credits
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-286">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-287" /> All
              question types
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-288">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-289" /> All
              board templates
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-290">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-291" /> PDF
              export with branding
            </li>
            <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-292">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-293" /> Valid
              for 12 months
            </li>
          </ul>
          <button className="w-full py-3 rounded-xl border-2 border-slate-200 font-bold text-slate-600 hover:border-indigo-600 hover:text-indigo-600 transition-colors" data-id="element-294">
            Buy Credits
          </button>
        </div>
      </div>
    </SlideLayout>;
}